export default "__VITE_ASSET__8332d40c__"